import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface CargoRecord {
  id?: number;
  cargos: string;
  estado?: number;
  funciones?:[];
}

@Injectable({
  providedIn: 'root'
})
export class CargosService {
  private apiUrl = `${environment.apiUrl}/api/cargo`;

  constructor(private http: HttpClient) {}

  getCargos(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener cargos:', error);
        return throwError(() => error);
      })
    );
  }

  getCargosActivos(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/activos`, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener cargos activos:', error);
        return throwError(() => error);
      })
    );
  }

  getCargoById(id: string | number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  createCargo(payload: CargoRecord): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  updateCargo(id: string | number, payload: CargoRecord): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }


  activarCargo(id: string | number): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  inactivarCargo(id: string | number): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }
}
